import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import { getProviders } from "../../services/providerService";
import { Link, useNavigate } from "react-router-dom";
import "./provider.css";
import CustomPagination from "../../../Common/Component/CustomPagination/CustomPagination";
import Loader from "../../../utils/Loader";
import { Tooltip } from "react-tooltip";

function ProviderListingComponent() {
  const userdata = useSelector((state) => state);
  let role = userdata?.login?.data?.role;
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(8);
  const [page, setPage] = useState(0);
  const [providerList, setProviderList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    _getProviderList();
  }, [page, limit, navigate]);

  const _getProviderList = (searchText, sortby) => {
    setLoading(true);
    getProviders(
      { page: page + 1, limit, searchKey: searchText, sortBy: sortby },
      (data) => {
        setProviderList(data?.items || []);
        setTotalPages(data?.totalPages || 0);
        setTotalItems(data?.totalItems || 0);
        setLoading(false);
      },
      dispatch
    );
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      _getProviderList(query, selectedSortValue);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const redirectToProfile = (provider) => {
    navigate("/admin/provider/profile", { state: { provider: provider?._id } });
  };

  const EditUser = (provider) => {
    navigate(`/admin/provider/edit`, {
      state: { provider: provider?._id },
    });
  };

  const [selectedSortValue, setSelectedSortValue] = useState("");

  const handleSelect = (eventKey) => {
    setSelectedSortValue(eventKey); // Update the state with the selected value
    _getProviderList(searchText, eventKey);
  };

  const colors = [
    "#66D4CF", // Mint
    // "#FFD60A", //  Yellow
    "#40C8E0", // Teal
    // "#BF5AF2", // Purple
    "#64D2FF", // Cyan
    "#E9E976", //   light yellow
    // "#5E5CE6", // Indigo
    "#e9c183", // light Orange
  ];

  const truncateEmail = (email, maxLength = 30) => {
    return email.length > maxLength ? email.slice(0, maxLength) + "..." : email;
  };

  return (
    <div className="Dashboard-wrapper provider-listing-page">
      {loading && <Loader />}
      <>
        <div className="add-doctor">
          <Form>
            <Form.Group controlId="searchInput">
              <Form.Control
                type="search"
                aria-label="Search"
                value={searchText}
                onChange={handleSearchChange}
                placeholder="Search providers..."
              />
            </Form.Group>
          </Form>
          <Button
            onClick={() => navigate("/admin/provider/create")}
            className="filled-btn"
          >
            Add Doctor
          </Button>

          <Dropdown className="patient-info-dropdown" onSelect={handleSelect}>
            <Dropdown.Toggle className="db-dropdown  h-100">
              {selectedSortValue === ""
                ? "Sort By"
                : selectedSortValue === "name-asc"
                  ? "Name A-Z"
                  : "Name Z-A"}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item eventKey="">Default</Dropdown.Item>
              <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
              <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
              {/* <Dropdown.Item eventKey="low-icbps">Low ICBPS</Dropdown.Item> */}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="doctor-listing mb-3">
          {providerList.length > 0 ? (
            providerList.map((provider, index) => (
              <div className="inner-wrapper-block" key={index}>
                <div className="doc-img-block">
                  <div
                    className="patient-initials"
                    style={{ background: colors[index % colors.length] }}
                  >
                    {`${provider?.firstName?.[0] || ""}${provider?.lastName?.[0] || ""
                      }`.toUpperCase()}
                  </div>
                </div>
                <div className="doc-details ">
                  {/* {provider.name} */}
                  <span className="text-capitalize">
                    {" "}
                    {provider?.firstName
                      ? truncateEmail(provider?.firstName || "", 13) +
                      " " +
                      truncateEmail(provider?.lastName || "", 13)
                      : "-"}
                  </span>
                  <span className="contact-no">{provider.contact}</span>
                  <span
                    className="email"
                    data-tooltip-id={`email-tooltip-${provider._id}`}
                  >
                    {truncateEmail(provider?.email || "", 30)}
                  </span>

                  <Tooltip id={`email-tooltip-${provider._id}`} place="top">
                    {provider?.email}
                  </Tooltip>
                </div>
                <div className="doctor-box-buttons">
                  <Button
                    className="outlined-btn"
                    onClick={() => {
                      EditUser(provider);
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    className="filled-btn"
                    onClick={() => redirectToProfile(provider)}
                  >
                    View
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <p>No providers found</p>
          )}
        </div>
      </>

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

export default ProviderListingComponent;
